const routes = {
    HOME: '/',
    ADDRESSUSER: '/addressUser',
    CART: '/cart',
    CHECKOUT: '/checkout',
    LOGIN: '/login',
    PRODUCT: '/product',
    PROFILE: '/profile',
    SIGNUP: '/signup',
    TRACKINGORDER: '/trackingOrder',
};

export default routes;
